import React from 'react';
import './styles.css';

const CancellationRefund = () => {
  const lastUpdated = new Date().toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <h1 className="legal-title">Cancellation &amp; Refund Policy</h1>
          <p className="legal-updated">Last Updated: {lastUpdated}</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Policy Overview</h2>
            <p>
              Douglas &amp; McCartney operates with transparency and fairness. This Cancellation &amp; Refund Policy
              explains how franchise applicants can withdraw their application and request a refund for fees paid. It covers
              payments collected through our website, Razorpay links, or any official Douglas &amp; McCartney payment channel.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. 7-Day Cancellation Window</h2>
            <p>
              We provide a <strong>7-day return period</strong> starting from the date a payment confirmation email or receipt
              is issued. Cancellation requests within this window qualify for a full refund of the franchise fee when:
            </p>
            <ul>
              <li>The request is submitted by the registered applicant or their authorised representative.</li>
              <li>The original payment confirmation and KYC documents are shared for verification.</li>
              <li>No onboarding assets (branding files, CRM credentials, playbooks) have been permanently downloaded.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Eligibility After 7 Days</h2>
            <p>
              Requests received after the 7-day window are treated as escalation cases. Partial refunds may be considered only if:
            </p>
            <ul>
              <li>The onboarding cohort for the applicant has not been scheduled.</li>
              <li>No franchise territory has been blocked for the applicant.</li>
              <li>No bespoke marketing, branding, or legal agreements have been initiated.</li>
            </ul>
            <p>Once onboarding begins or assets are provisioned, fees become non-refundable.</p>
          </section>

          <section className="legal-section">
            <h2>4. Non-Refundable Situations</h2>
            <ul>
              <li>Breaches of the franchise agreement or misrepresentation of information.</li>
              <li>Failure to complete KYC or compliance requirements within communicated timelines.</li>
              <li>Chargeback attempts after services or assets have been delivered.</li>
              <li>Cancellation requests submitted by third parties without applicant consent.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Refund Timelines &amp; Mode</h2>
            <p>
              Approved refunds are issued to the original payment source within <strong>5-7 business days</strong>. Processing
              time depends on the issuing bank or payment gateway. Once a refund is initiated, we will email you the UTR or
              transaction reference number for tracking.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. How to Raise a Request</h2>
            <p>
              Email our compliance desk with the subject line "Franchise Cancellation Request" and include:
            </p>
            <ul>
              <li>Registered full name and contact number</li>
              <li>Payment receipt or Razorpay reference number</li>
              <li>Date of payment and franchise territory applied for</li>
              <li>Reason for cancellation</li>
              <li>Bank details if the original payment mode is unavailable</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Contact &amp; Escalation</h2>
            <p>For quick resolution, reach out to our support and finance desks:</p>
            <p className="contact-info">
              Support: info@douglasmccartney.com<br />
              Phone: +91 94490 73566 (Monday-Saturday, 10 AM - 7 PM IST)<br />
            </p>
            <p>
              If your concern remains unresolved beyond 7 working days, escalate it to{' '}
              <a href="mailto:compliance@douglasmccartney.com" className="legal-inline-link">
                info@douglasmccartney.com
              </a>.
            </p>
          </section>
        </div>

        <div className="legal-footer">
          <button onClick={() => window.close()} className="back-button">Close Window</button>
        </div>
      </div>
    </div>
  );
};

export default CancellationRefund;
